import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { AmplifyProvider } from "@aws-amplify/ui-react";
import { Amplify } from "aws-amplify";
import App from "./App";
import awsExports from "./aws-exports";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

Amplify.configure(awsExports);

ReactDOM.render(
  <AmplifyProvider colorMode="dark">
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AmplifyProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
